import React, { createContext, useContext } from 'react';

/**
 * Context to share repositioning state across components
 * Allows damage animation hook to check if a unit is repositioning
 */
const RepositioningContext = createContext(null);

export const RepositioningProvider = ({ children, isUnitRepositioning }) => {
  return (
    <RepositioningContext.Provider value={{ isUnitRepositioning }}>
      {children}
    </RepositioningContext.Provider>
  );
};

export const useRepositioningContext = () => {
  return useContext(RepositioningContext);
};

